module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-select",
    class: {
      'is-disabled': _vm.disabled, 'is-show': _vm.show
    }
  }, [_c('div', {
    staticClass: "select-mark"
  }, [_c('vbl-icon', {
    attrs: {
      "type": "ion-arrow-down-b"
    }
  })], 1), _c('div', {
    staticClass: "selected",
    on: {
      "click": function($event) {
        !_vm.disabled && (_vm.show = !_vm.show)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dataText || _vm.placeholder) + "\n    ")]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "list"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48796b1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblSelect/src/vblSelect.vue
// module id = 262
// module chunks = 0